export const trimIfString = (value: unknown) => (typeof value === 'string' ? value.trim() : value)
